import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { api } from "../../services/api";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import BarcodeModal from "../Components/BarcodeScanner";
import Foto from "../Components/Foto";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Spinner, Table, Button, Form, Badge, Card, Row, Col, ProgressBar } from 'react-bootstrap';
import Swal from "sweetalert2";
import {
    FaBarcode,
    FaSearch,
    FaCheck,
    FaStore,
    FaClipboardList,
    FaSyncAlt,
    FaEdit,
    FaCamera,
    FaCompressAlt,
    FaExpandAlt
} from "react-icons/fa";

const parseCurrencyToNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return v;
    const s = String(v).replace(/\./g, "").replace(/,/g, ".");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

const formatarMoeda = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseCurrencyToNumber(val));

function ModalListaProdutos({ show, produtos, onSelect, onClose }) {
    if (!show) return null;
    return (
        <Modal show={show} onHide={onClose} centered size="md">
            <Modal.Header closeButton className="py-2 card-header-red text-white">
                <Modal.Title className="fs-6 fw-bold">
                    🔍 Selecione o Produto ({produtos.length})
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-2" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <div className="list-group">
                    {produtos.map((item, idx) => {
                        const eanItem = item.ean_principal || item.codacesso || item.ean || "N/A";
                        const pNormal = item.precovalidnormal || item.precobasenormal || 0;
                        const pPromoV = item.promovarejo || 0;
                        const pPromoA = item.promoapp || 0;
                        const precos = [pNormal, pPromoV, pPromoA].filter(p => p > 0);
                        const menorPrecoFloresta = precos.length > 0 ? Math.min(...precos) : pNormal;

                        return (
                            <button
                                key={idx}
                                type="button"
                                className="list-group-item list-group-item-action p-2 text-start"
                                onClick={() => onSelect(item)}
                            >
                                <div className="fw-bold text-dark mb-1">{item.desccompleta}</div>
                                <div className="row g-1 text-muted extra-small">
                                    <div className="col-6">
                                        <span>Cód: <strong>{item.seqproduto}</strong> | Emb: <strong>{item.embalagem || 'UN'}</strong></span>
                                    </div>
                                    <div className="col-6 text-end">
                                        <span>Preço Floresta: <strong className="text-danger">{formatarMoeda(menorPrecoFloresta)}</strong></span>
                                    </div>
                                    <div className="col-12 mt-1">
                                        <span>EAN Principal: <strong>{eanItem}</strong></span>
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default function PesquisaPrecoColeta() {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const paramLojaRaw = queryParams.get('loja');
    const paramPesquisa = queryParams.get('pesquisa');
    const isViaLink = Boolean(paramLojaRaw && paramPesquisa);

    const lojaInicial = useMemo(() => {
        if (paramLojaRaw) {
            const num = parseInt(paramLojaRaw, 10);
            return isNaN(num) ? paramLojaRaw : String(num);
        }
        const stLoja = localStorage.getItem("loja") || localStorage.getItem("lojaprincipal") || '1';
        return String(parseInt(stLoja, 10) || '1');
    }, [paramLojaRaw]);

    const [loja, setLoja] = useState(lojaInicial);
    const [lojasLista, setLojasLista] = useState([]);
    const [pesquisasAtivas, setPesquisasAtivas] = useState([]);
    const [concorrentes, setConcorrentes] = useState([]);

    const [pesquisaSel, setPesquisaSel] = useState(null);
    const [concorrenteSel, setConcorrenteSel] = useState('');

    const [esconderPainel, setEsconderPainel] = useState(false);
    const [soPendentes, setSoPendentes] = useState(false);
    const [itensColeta, setItensColeta] = useState([]);
    const [filtroTexto, setFiltroTexto] = useState('');
    const [loading, setLoading] = useState(false);

    const [eanInput, setEanInput] = useState('');
    const [prodAtual, setProdAtual] = useState(null);
    const [precoConcDigitado, setPrecoConcDigitado] = useState('');
    const [precoPromoConcDigitado, setPrecoPromoConcDigitado] = useState('');

    const [isSimilar, setIsSimilar] = useState(false);
    const [similarNome, setSimilarNome] = useState('');
    const [similarEan, setSimilarEan] = useState('');

    const [showModalColeta, setShowModalColeta] = useState(false);
    const [listaProdutosBusca, setListaProdutosBusca] = useState([]);
    const [showListaModal, setShowListaModal] = useState(false);

    const [showScanner, setShowScanner] = useState(false);
    const [isProcessingScan, setIsProcessingScan] = useState(false);
    const [scanTarget, setScanTarget] = useState('ean');
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const inputEanRef = useRef(null);
    const inputPrecoRef = useRef(null);
    const audioRef = useRef(new Audio("/beep.mp3"));

    const chapa = localStorage.getItem("chapa") || "0";

    useEffect(() => {
        if (!isViaLink) {
            const temPermissao = localStorage.getItem("PESQUISACOLETA") === "S";
            if (!temPermissao) {
                Swal.fire({
                    title: "Acesso Negado",
                    text: "Você não possui permissão para acessar o módulo de Coleta de Preços.",
                    icon: "error",
                    confirmButtonColor: "#991b1b"
                }).then(() => {
                    navigate("/arbor/home");
                });
            }
        }
    }, [isViaLink, navigate]);

    const playBeep = useCallback(() => {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((e) => console.log("Erro ao tocar beep:", e));
    }, []);

    const carregarLojas = useCallback(async () => {
        try {
            const res = await api.get('/lojas/localizacao');
            if (Array.isArray(res.data) && res.data.length > 0) {
                const lojasPermitidasStr = localStorage.getItem("lojasPermitidas");
                let permitidas = lojasPermitidasStr ? JSON.parse(lojasPermitidasStr) : [];
                
                if (permitidas.length > 0 && !isViaLink) {
                    const filtradas = res.data.filter(lj => {
                        const cod = String(lj.codigo || lj.cod_emp).padStart(2, '0');
                        return permitidas.includes(cod);
                    });
                    setLojasLista(filtradas.length > 0 ? filtradas : res.data);
                } else {
                    setLojasLista(res.data);
                }
            }
        } catch (err) {
            setLojasLista([
                { codigo: 1, nome: 'Loja 01' },
                { codigo: 2, nome: 'Loja 02' },
                { codigo: 5, nome: 'Loja 05' },
                { codigo: 7, nome: 'Loja 07' },
                { codigo: 10, nome: 'Loja 10' }
            ]);
        }
    }, [isViaLink]);

    const carregarConcorrentes = useCallback(async () => {
        try {
            const res = await api.get('/SAP/pesquisa/concorrente');
            setConcorrentes(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error("Erro ao carregar concorrentes", err);
        }
    }, []);

    const carregarPesquisasAtivas = useCallback(async (codLoja, idPesquisaDireta = null) => {
        setLoading(true);
        try {
            const res = await api.get(`/SAP/pesquisa/coleta/ativas/${codLoja}`);
            const lista = Array.isArray(res.data) ? res.data : [];
            setPesquisasAtivas(lista);

            if (idPesquisaDireta) {
                const encontrada = lista.find(p => String(p.pesq_id ?? p.PESQ_ID) === String(idPesquisaDireta));
                if (encontrada) {
                    setPesquisaSel(encontrada);
                }
            } else {
                setPesquisaSel(null);
                setConcorrenteSel('');
                setItensColeta([]);
            }
        } catch (err) {
            console.error("Erro ao carregar pesquisas ativas", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        carregarLojas();
        carregarConcorrentes();
        carregarPesquisasAtivas(loja, paramPesquisa);
    }, [carregarLojas, carregarConcorrentes, carregarPesquisasAtivas, loja, paramPesquisa]);

    const handleLojaChange = (e) => {
        if (isViaLink) return;
        const novaLoja = e.target.value;
        setLoja(novaLoja);
        carregarPesquisasAtivas(novaLoja);
    };

    const concorrentesDaPesquisa = useMemo(() => {
        if (!pesquisaSel) return [];
        const concsStr = pesquisaSel.pesq_concorrentes ?? pesquisaSel.PESQ_CONCORRENTES ?? '';
        const ids = concsStr.split(',').map(s => String(s.trim()));

        return concorrentes.filter(c => {
            const codigo = String(c.conc_codigo ?? c.CONC_CODIGO);
            return ids.includes(codigo);
        });
    }, [pesquisaSel, concorrentes]);

    const carregarItensColeta = useCallback(async () => {
        if (!pesquisaSel || !concorrenteSel) return;
        const pesqId = pesquisaSel.pesq_id ?? pesquisaSel.PESQ_ID;

        setLoading(true);
        try {
            const res = await api.get('/SAP/pesquisa/coleta/itens', {
                params: { pesqid: pesqId, concid: concorrenteSel }
            });
            setItensColeta(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error("Erro ao carregar itens da coleta", err);
        } finally {
            setLoading(false);
        }
    }, [pesquisaSel, concorrenteSel]);

    useEffect(() => {
        if (pesquisaSel && concorrenteSel) {
            carregarItensColeta();
        }
    }, [pesquisaSel, concorrenteSel, carregarItensColeta]);

    const progresso = useMemo(() => {
        if (itensColeta.length === 0) return { total: 0, coletados: 0, perc: 0 };
        const coletados = itensColeta.filter(i => {
            const p = i.pprod_preco_conc ?? i.PPROD_PRECO_CONC ?? 0;
            return p > 0;
        }).length;
        const total = itensColeta.length;
        const perc = total > 0 ? Math.round((coletados / total) * 100) : 0;
        return { total, coletados, perc };
    }, [itensColeta]);

    const abrirModalParaItem = (prod) => {
        setProdAtual(prod);
        setPrecoConcDigitado(prod.pprod_preco_conc || '');
        setPrecoPromoConcDigitado(prod.pprod_preco_promo_conc || '');
        setIsSimilar((prod.pprod_is_similar ?? prod.PPROD_IS_SIMILAR) === 'S');
        setSimilarNome(prod.pprod_similar_nome || '');
        setSimilarEan(prod.pprod_similar_ean || '');
        setShowModalColeta(true);
        setTimeout(() => inputPrecoRef.current?.focus(), 200);
    };

    const handleMarkNotFound = () => {
        setPrecoConcDigitado('0.01');
        setPrecoPromoConcDigitado('');
    };

    const handleBuscarEan = async (termoParaBuscar = eanInput) => {
        if (!termoParaBuscar || !pesquisaSel || !concorrenteSel) return;

        const termoLimpo = String(termoParaBuscar).trim();
        const isTipoLista = (pesquisaSel.pesq_tipo ?? pesquisaSel.PESQ_TIPO) === 'L';

        const itemExistente = itensColeta.find(i => {
            const ean = String(i.pprod_ean ?? i.PPROD_EAN ?? '');
            const cod = String(i.pprod_codigo ?? i.PPROD_CODIGO ?? '');
            return ean === termoLimpo || cod === termoLimpo;
        });

        if (itemExistente) {
            abrirModalParaItem(itemExistente);
            return;
        }

        if (isTipoLista) {
            Swal.fire({
                icon: 'warning',
                title: 'Produto Não Permitido',
                text: 'Esta pesquisa é do tipo LISTA. Apenas os produtos cadastrados podem ser pesquisados.',
                confirmButtonColor: '#991b1b'
            });
            return;
        }

        try {
            setLoading(true);
            const url = `AUDIT/produto?loja=${loja}&pesquisa=${encodeURIComponent(termoLimpo)}`;
            const res = await api.get(url);
            const data = Array.isArray(res.data) ? res.data : [];

            if (data.length === 0) {
                Swal.fire("Atenção", "Nenhum produto encontrado.", "warning");
                return;
            }

            const prodsUnicos = data.filter((item, index, self) =>
                index === self.findIndex((p) => p.codigo === item.codigo)
            );

            if (prodsUnicos.length > 1) {
                setListaProdutosBusca(prodsUnicos);
                setShowListaModal(true);
            } else {
                abrirModalParaItem(prodsUnicos[0]);
            }
        } catch (err) {
            Swal.fire("Erro", "Falha ao buscar produto na auditoria.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleSalvarColeta = async () => {
        const pNum = parseFloat(String(precoConcDigitado).replace(',', '.'));
        const pPromoNum = parseFloat(String(precoPromoConcDigitado || '0').replace(',', '.'));

        if (isNaN(pNum) || pNum < 0) {
            Swal.fire("Atenção", "Informe o preço coletado no concorrente.", "warning");
            return;
        }

        const permiteSim = (pesquisaSel?.pesq_permite_similar ?? pesquisaSel?.PESQ_PERMITE_SIMILAR) === 'S';

        if (permiteSim && isSimilar && (!similarNome || !similarEan)) {
            Swal.fire("Atenção", "Preencha o Nome/Marca e EAN do produto similar.", "warning");
            return;
        }

        try {
            setLoading(true);
            const pesqId = pesquisaSel.pesq_id ?? pesquisaSel.PESQ_ID;
            const codProd = prodAtual.pprod_codigo ?? prodAtual.PPROD_CODIGO ?? prodAtual.codigo;
            const eanProd = (prodAtual.pprod_ean ?? prodAtual.PPROD_EAN ?? prodAtual.ean_principal ?? prodAtual.ean) || 0;
            const descProd = prodAtual.pprod_descricao ?? prodAtual.PPROD_DESCRICAO ?? prodAtual.descricao ?? prodAtual.desccompleta;
            const embProd = prodAtual.pprod_emb ?? prodAtual.PPROD_EMB ?? prodAtual.embalagem ?? 'UN';

            await api.post('/SAP/pesquisa/coleta/gravar', {
                pesq_id: pesqId,
                conc_codigo: Number(concorrenteSel),
                pprod_codigo: Number(codProd),
                pprod_ean: Number(eanProd),
                pprod_descricao: descProd,
                pprod_emb: embProd,
                pprod_preco_conc: pNum,
                pprod_preco_promo_conc: pPromoNum,
                pprod_is_similar: (permiteSim && isSimilar) ? 'S' : 'N',
                pprod_similar_nome: (permiteSim && isSimilar) ? similarNome : '',
                pprod_similar_ean: (permiteSim && isSimilar && similarEan) ? Number(similarEan) : 0,
                precobasenormal: prodAtual.precovalidnormal || prodAtual.precobasenormal || 0,
                promovarejo: prodAtual.precovalidpromoc || prodAtual.promovarejo || 0,
                promoapp: prodAtual.promoapp || 0,
                pprod_preco_loja: prodAtual.custo || prodAtual.pprod_preco_loja || 0,
                custo: prodAtual.custo || 0,
                loja: Number(loja),
                matricula: Number(chapa)
            });

            setShowModalColeta(false);
            setEanInput('');
            setPrecoConcDigitado('');
            setPrecoPromoConcDigitado('');
            carregarItensColeta();

            setTimeout(() => inputEanRef.current?.focus(), 200);
        } catch (err) {
            Swal.fire("Erro", "Falha ao gravar preço do concorrente.", "error");
        } finally {
            setLoading(false);
        }
    };

    const itensFiltrados = useMemo(() => {
        let lista = itensColeta;

        // Filtro frontend para exibir apenas itens pendentes (sem preço coletado)
        if (soPendentes) {
            lista = lista.filter(i => {
                const pConc = i.pprod_preco_conc ?? i.PPROD_PRECO_CONC ?? 0;
                return pConc <= 0;
            });
        }

        if (!filtroTexto) return lista;
        const txt = filtroTexto.toLowerCase();
        return lista.filter(i => {
            const desc = String(i.pprod_descricao ?? i.PPROD_DESCRICAO ?? '').toLowerCase();
            const ean = String(i.pprod_ean ?? i.PPROD_EAN ?? '');
            const cod = String(i.pprod_codigo ?? i.PPROD_CODIGO ?? '');
            return desc.includes(txt) || ean.includes(txt) || cod.includes(txt);
        });
    }, [itensColeta, filtroTexto, soPendentes]);

    const concNomeSel = useMemo(() => {
        const found = concorrentes.find(c => String(c.conc_codigo ?? c.CONC_CODIGO) === String(concorrenteSel));
        return found ? (found.conc_nome ?? found.CONC_NOME) : '';
    }, [concorrenteSel, concorrentes]);

    const permiteSimilarPesquisa = (pesquisaSel?.pesq_permite_similar ?? pesquisaSel?.PESQ_PERMITE_SIMILAR) === 'S';

    return (
        <div className="bg-light min-vh-100">
            <style>{`
                .btn-custom-red { background-color: #991b1b !important; border-color: #991b1b !important; color: #fff !important; }
                .btn-custom-red:hover { background-color: #7f1d1d !important; border-color: #7f1d1d !important; }
                .card-header-red { background-color: #991b1b !important; color: #fff !important; }
                .card-item-mobile { border-left: 4px solid #991b1b; }
                .card-item-coletado { border-left: 4px solid #198754; background-color: #f8fff9; }
            `}</style>

            <Menu modulo="ARBOR" />

            <Modal show={loading} centered backdrop="static" keyboard={false} size="sm">
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" style={{ color: '#991b1b' }} className="mb-2" />
                    <div className="fw-bold text-dark">Processando...</div>
                </Modal.Body>
            </Modal>

            <main className="container-fluid" style={{ paddingTop: '95px' }}>
                <Card className="shadow-sm border-0 mb-2">
                    <Card.Body className="p-2">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            {esconderPainel && pesquisaSel && (
                                <div className="small text-truncate fw-bold text-dark me-2">
                                    <Badge bg="danger" className="me-1">LJ {loja}</Badge>
                                    <span className="text-primary">{concNomeSel}</span> - {pesquisaSel.pesq_descricao ?? pesquisaSel.PESQ_DESCRICAO}
                                </div>
                            )}

                            <Button
                                size="sm"
                                variant={esconderPainel ? "outline-primary" : "outline-secondary"}
                                className="fw-bold extra-small ms-auto py-0 px-2"
                                onClick={() => setEsconderPainel(!esconderPainel)}
                            >
                                {esconderPainel ? (
                                    <><FaExpandAlt className="me-1" /> Mostrar Seletores</>
                                ) : (
                                    <><FaCompressAlt className="me-1" /> Modo Foco (Mais Espaço)</>
                                )}
                            </Button>
                        </div>

                        {!esconderPainel && (
                            <Row className="g-2 align-items-end mt-1">
                                <Col md={3} xs={12}>
                                    <Form.Label className="small fw-bold mb-1">Loja Atual</Form.Label>
                                    <Form.Select size="sm" value={loja} disabled={isViaLink} onChange={handleLojaChange}>
                                        {lojasLista.map(lj => {
                                            const c = String(parseInt(lj.codigo || lj.cod_emp, 10));
                                            return (
                                                <option key={c} value={c}>
                                                    {lj.nome || lj.razao || `Loja ${c.padStart(2, '0')}`}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Col>

                                <Col md={5} xs={12}>
                                    <Form.Label className="small fw-bold mb-1">Pesquisa de Preço Ativa</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        disabled={isViaLink}
                                        value={pesquisaSel ? (pesquisaSel.pesq_id ?? pesquisaSel.PESQ_ID) : ''}
                                        onChange={e => {
                                            const found = pesquisasAtivas.find(p => String(p.pesq_id ?? p.PESQ_ID) === String(e.target.value));
                                            setPesquisaSel(found || null);
                                            setConcorrenteSel('');
                                        }}
                                    >
                                        <option value="">-- Selecione a Pesquisa --</option>
                                        {pesquisasAtivas.map(p => {
                                            const id = p.pesq_id ?? p.PESQ_ID;
                                            const desc = p.pesq_descricao ?? p.PESQ_DESCRICAO;
                                            const tipo = (p.pesq_tipo ?? p.PESQ_TIPO) === 'L' ? 'Lista' : 'Via Coleta';
                                            return (
                                                <option key={id} value={id}>
                                                    #{id} - {desc} ({tipo})
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Col>

                                <Col md={4} xs={12}>
                                    <Form.Label className="small fw-bold mb-1">Concorrente Visitado</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        disabled={!pesquisaSel}
                                        value={concorrenteSel}
                                        onChange={e => setConcorrenteSel(e.target.value)}
                                    >
                                        <option value="">-- Selecione o Concorrente --</option>
                                        {concorrentesDaPesquisa.map(c => {
                                            const cod = c.conc_codigo ?? c.CONC_CODIGO;
                                            const nome = c.conc_nome ?? c.CONC_NOME;
                                            return (
                                                <option key={cod} value={cod}>{nome}</option>
                                            );
                                        })}
                                    </Form.Select>
                                </Col>
                            </Row>
                        )}
                    </Card.Body>
                </Card>

                {pesquisaSel && concorrenteSel ? (
                    <>
                        <Card className="shadow-sm border-0 mb-2">
                            <Card.Body className="p-2">
                                {(pesquisaSel.pesq_tipo ?? pesquisaSel.PESQ_TIPO) === 'L' && (
                                    <div className="mb-2">
                                        <div className="d-flex justify-content-between extra-small fw-bold mb-1">
                                            <span>Progresso da Coleta</span>
                                            <span>{progresso.coletados} de {progresso.total} itens ({progresso.perc}%)</span>
                                        </div>
                                        <ProgressBar now={progresso.perc} variant={progresso.perc === 100 ? "success" : "danger"} style={{ height: '8px' }} />
                                    </div>
                                )}

                                <Row className="g-2 align-items-center">
                                    <Col md={7} xs={12}>
                                        <Form.Label className="extra-small fw-bold mb-1">
                                            <FaBarcode className="me-1" /> Bipar / Digitar EAN, Código ou Descrição
                                        </Form.Label>
                                        <div className="d-flex gap-2">
                                            <Form.Control
                                                ref={inputEanRef}
                                                type="text"
                                                placeholder="EAN, código ou nome..."
                                                className="fw-bold fs-6"
                                                value={eanInput}
                                                onChange={e => setEanInput(e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleBuscarEan();
                                                    }
                                                }}
                                            />
                                            <Button className="btn-custom-red fw-bold text-nowrap px-3" onClick={() => handleBuscarEan()}>
                                                <FaSearch className="me-1" /> Buscar
                                            </Button>
                                            <Button variant="secondary" className="fw-bold text-nowrap px-3" onClick={() => { setScanTarget('ean'); setShowScanner(true); }}>
                                                <FaCamera />
                                            </Button>
                                        </div>
                                    </Col>

                                    <Col md={3} xs={12}>
                                        <Form.Label className="extra-small fw-bold mb-1"><FaSearch className="me-1" /> Filtrar Lista</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            placeholder="Filtrar na lista..."
                                            value={filtroTexto}
                                            onChange={e => setFiltroTexto(e.target.value)}
                                        />
                                    </Col>

                                    <Col md={2} xs={12} className="d-flex align-items-end pt-2">
                                        <Form.Check
                                            type="checkbox"
                                            id="chk-so-pendentes"
                                            label="Exibir somente pendentes"
                                            checked={soPendentes}
                                            onChange={e => setSoPendentes(e.target.checked)}
                                            className="fw-bold extra-small text-danger"
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0 mb-4">
                            <Card.Header className="card-header-red fw-bold d-flex justify-content-between align-items-center py-2 text-white">
                                <span className="small"><FaClipboardList className="me-2" /> Relação de Produtos Coletados</span>
                                <Button size="sm" variant="light" className="fw-bold text-danger py-0 extra-small" onClick={carregarItensColeta}>
                                    <FaSyncAlt className="me-1" /> Atualizar
                                </Button>
                            </Card.Header>

                            <div style={{ maxHeight: esconderPainel ? '75vh' : '52vh', overflowY: 'auto' }}>
                                <div className="d-block d-md-none p-2">
                                    {itensFiltrados.length > 0 ? (
                                        itensFiltrados.map((item, idx) => {
                                            const cod = item.pprod_codigo ?? item.PPROD_CODIGO;
                                            const ean = item.pprod_ean ?? item.PPROD_EAN;
                                            const desc = item.pprod_descricao ?? item.PPROD_DESCRICAO;
                                            const pRegLoja = item.pprod_preco_reg_loja || item.precobasenormal || item.pprod_preco_loja || 0;
                                            const pPromoLoja = item.pprod_preco_promo_loja || item.promovarejo || 0;
                                            const pConc = item.pprod_preco_conc ?? item.PPROD_PRECO_CONC ?? 0;
                                            const pPromoConc = item.pprod_preco_promo_conc ?? item.PPROD_PRECO_PROMO_CONC ?? 0;
                                            const coletado = pConc > 0;
                                            const naoEncontrado = pConc === 0.01;

                                            return (
                                                <Card key={idx} className={`mb-2 shadow-sm border-0 ${coletado ? 'card-item-coletado' : 'card-item-mobile'}`}>
                                                    <Card.Body className="p-2">
                                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                            <div 
                                                                style={{ cursor: 'pointer' }} 
                                                                onClick={() => setFotoSelecionada({
                                                                    foto: `https://cdn-cosmos.bluesoft.com.br/products/${ean}`,
                                                                    nome: desc,
                                                                    info01: `Cód: ${cod} | EAN: ${ean}`,
                                                                    info02: `Reg. Floresta: ${formatarMoeda(pRegLoja)}`
                                                                })}
                                                            >
                                                                <img
                                                                    src={`https://cdn-cosmos.bluesoft.com.br/products/${ean}`}
                                                                    alt="prod"
                                                                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                                                                    onError={e => e.target.src = "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"}
                                                                />
                                                            </div>
                                                            <div>
                                                                <div className="fw-bold text-dark fs-6">{desc}</div>
                                                                <div className="extra-small text-muted">
                                                                    Cód: <strong className="text-dark">{cod}</strong> | EAN: <strong>{ean}</strong>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row g-1 align-items-center bg-white p-2 rounded border text-center">
                                                            <div className="col-4">
                                                                <span className="extra-small text-muted d-block">Reg. Floresta</span>
                                                                <span className="fw-bold text-dark fs-7">{formatarMoeda(pRegLoja)}</span>
                                                            </div>
                                                            <div className="col-4">
                                                                <span className="extra-small text-muted d-block">Promo Floresta</span>
                                                                <span className="fw-bold text-success fs-7">{pPromoLoja > 0 ? formatarMoeda(pPromoLoja) : '-'}</span>
                                                            </div>
                                                            <div className="col-4">
                                                                <span className="extra-small text-muted d-block">Concorrente</span>
                                                                {naoEncontrado ? (
                                                                    <Badge bg="secondary" className="fs-8">Não Encontrado</Badge>
                                                                ) : coletado ? (
                                                                    <div>
                                                                        <div className="fw-bold text-danger fs-7">Reg: {formatarMoeda(pConc)}</div>
                                                                        {pPromoConc > 0 && <div className="fw-bold text-success extra-small">Promo: {formatarMoeda(pPromoConc)}</div>}
                                                                    </div>
                                                                ) : (
                                                                    <Badge bg="warning" text="dark" className="extra-small">Pendente</Badge>
                                                                )}
                                                            </div>
                                                            <div className="col-12 mt-2 text-end">
                                                                <Button
                                                                    size="sm"
                                                                    variant={coletado ? "outline-secondary" : "danger"}
                                                                    className="fw-bold py-1 px-3 extra-small"
                                                                    onClick={() => abrirModalParaItem(item)}
                                                                >
                                                                    <FaEdit className="me-1" /> {coletado ? "Alterar Coleta" : "Coletar Preço"}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center text-muted py-4 small">
                                            Nenhum produto encontrado com os filtros atuais.
                                        </div>
                                    )}
                                </div>

                                <div className="d-none d-md-block">
                                    <Table hover striped className="mb-0 align-middle text-center small">
                                        <thead className="table-secondary sticky-top">
                                            <tr>
                                                <th style={{ width: '45px' }}>Foto</th>
                                                <th>Cód.</th>
                                                <th>EAN</th>
                                                <th>Descrição Produto</th>
                                                <th>Emb</th>
                                                <th>Preço Reg. Floresta</th>
                                                <th>Preço Promo Floresta</th>
                                                <th>Preço Concorrente</th>
                                                <th>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {itensFiltrados.length > 0 ? (
                                                itensFiltrados.map((item, idx) => {
                                                    const cod = item.pprod_codigo ?? item.PPROD_CODIGO;
                                                    const ean = item.pprod_ean ?? item.PPROD_EAN;
                                                    const desc = item.pprod_descricao ?? item.PPROD_DESCRICAO;
                                                    const emb = item.pprod_emb ?? item.PPROD_EMB ?? 'UN';
                                                    const pRegLoja = item.pprod_preco_reg_loja || item.precobasenormal || item.pprod_preco_loja || 0;
                                                    const pPromoLoja = item.pprod_preco_promo_loja || item.promovarejo || 0;
                                                    const pConc = item.pprod_preco_conc ?? item.PPROD_PRECO_CONC ?? 0;
                                                    const pPromoConc = item.pprod_preco_promo_conc ?? item.PPROD_PRECO_PROMO_CONC ?? 0;
                                                    const coletado = pConc > 0;
                                                    const naoEncontrado = pConc === 0.01;

                                                    return (
                                                        <tr key={idx} className={coletado ? "table-success bg-opacity-10" : ""}>
                                                            <td>
                                                                <div 
                                                                    style={{ cursor: 'pointer', display: 'inline-block' }} 
                                                                    onClick={() => setFotoSelecionada({
                                                                        foto: `https://cdn-cosmos.bluesoft.com.br/products/${ean}`,
                                                                        nome: desc,
                                                                        info01: `Cód: ${cod} | EAN: ${ean}`,
                                                                        info02: `Reg. Floresta: ${formatarMoeda(pRegLoja)}`
                                                                    })}
                                                                >
                                                                    <img
                                                                        src={`https://cdn-cosmos.bluesoft.com.br/products/${ean}`}
                                                                        alt="prod"
                                                                        style={{ width: '35px', height: '35px', objectFit: 'contain' }}
                                                                        onError={e => e.target.src = "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="fw-bold">{cod}</td>
                                                            <td>{ean}</td>
                                                            <td className="text-start fw-bold">{desc}</td>
                                                            <td>{emb}</td>
                                                            <td className="fw-bold text-dark">{pRegLoja > 0 ? formatarMoeda(pRegLoja) : '-'}</td>
                                                            <td className="fw-bold text-success">{pPromoLoja > 0 ? formatarMoeda(pPromoLoja) : '-'}</td>
                                                            <td>
                                                                {naoEncontrado ? (
                                                                    <Badge bg="secondary">Não Encontrado</Badge>
                                                                ) : coletado ? (
                                                                    <div>
                                                                        <span className="fw-bold text-danger">Reg: {formatarMoeda(pConc)}</span>
                                                                        {pPromoConc > 0 && <div className="fw-bold text-success extra-small">Promo: {formatarMoeda(pPromoConc)}</div>}
                                                                    </div>
                                                                ) : (
                                                                    <Badge bg="warning" text="dark">Pendente</Badge>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    size="sm"
                                                                    variant={coletado ? "outline-secondary" : "danger"}
                                                                    className="fw-bold py-0 px-2"
                                                                    onClick={() => abrirModalParaItem(item)}
                                                                >
                                                                    <FaEdit className="me-1" /> {coletado ? "Alterar" : "Coletar"}
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-muted py-4">
                                                        Nenhum produto encontrado com os filtros atuais.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Card>
                    </>
                ) : (
                    <div className="alert alert-info text-center py-4 shadow-sm border-0">
                        <FaStore className="fs-1 mb-2 text-secondary d-block mx-auto" />
                        <h5>Selecione a Pesquisa de Preço e o Concorrente</h5>
                        <p className="mb-0 text-muted">Escolha nos campos acima para iniciar o processo de coleta em campo.</p>
                    </div>
                )}
            </main>

            <ModalListaProdutos
                show={showListaModal}
                produtos={listaProdutosBusca}
                onSelect={(prod) => {
                    setShowListaModal(false);
                    abrirModalParaItem(prod);
                }}
                onClose={() => setShowListaModal(false)}
            />

            <Modal show={showModalColeta} onHide={() => setShowModalColeta(false)} centered backdrop="static">
                <Modal.Header closeButton className="card-header-red py-2 text-white">
                    <Modal.Title className="fs-6 fw-bold">Informe o Preço Encontrado</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {prodAtual && (
                        <div>
                            <div className="d-flex align-items-center gap-2 bg-light p-2 rounded mb-3 border">
                                <div 
                                    style={{ cursor: 'pointer' }} 
                                    onClick={() => setFotoSelecionada({
                                        foto: `https://cdn-cosmos.bluesoft.com.br/products/${prodAtual.pprod_ean ?? prodAtual.PPROD_EAN ?? prodAtual.ean_principal ?? prodAtual.ean}`,
                                        nome: prodAtual.pprod_descricao ?? prodAtual.desccompleta ?? prodAtual.descricao,
                                        info01: `Cód: ${prodAtual.pprod_codigo ?? prodAtual.codigo} | EAN: ${prodAtual.pprod_ean ?? prodAtual.ean}`,
                                        info02: `Reg. Floresta: ${formatarMoeda(prodAtual.pprod_preco_reg_loja || prodAtual.precobasenormal || 0)}`
                                    })}
                                >
                                    <img
                                        src={`https://cdn-cosmos.bluesoft.com.br/products/${prodAtual.pprod_ean ?? prodAtual.PPROD_EAN ?? prodAtual.ean_principal ?? prodAtual.ean}`}
                                        alt="Foto"
                                        style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                        onError={e => e.target.src = "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"}
                                    />
                                </div>
                                <div>
                                    <div className="fw-bold text-dark fs-6">{prodAtual.pprod_descricao ?? prodAtual.desccompleta ?? prodAtual.descricao}</div>
                                    <div className="extra-small text-muted">
                                        Cód: <strong>{prodAtual.pprod_codigo ?? prodAtual.PPROD_CODIGO ?? prodAtual.codigo}</strong> | EAN: <strong>{prodAtual.pprod_ean ?? prodAtual.PPROD_EAN ?? prodAtual.ean_principal ?? prodAtual.ean}</strong>
                                    </div>
                                    <div className="extra-small fw-bold text-primary">
                                        Reg. Floresta: {formatarMoeda(prodAtual.pprod_preco_reg_loja || prodAtual.precobasenormal || 0)}
                                    </div>
                                </div>
                            </div>

                            <Row className="g-2 mb-3">
                                <Col md={6}>
                                    <Form.Label className="fw-bold text-danger extra-small">Preço Regular Concorrente (R$)</Form.Label>
                                    <Form.Control
                                        ref={inputPrecoRef}
                                        type="number"
                                        step="0.01"
                                        placeholder="0.00"
                                        className="fs-4 text-center fw-bold text-danger"
                                        value={precoConcDigitado}
                                        onChange={e => setPrecoConcDigitado(e.target.value)}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="fw-bold text-success extra-small">Preço Promo Concorrente (R$)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        placeholder="0.00"
                                        className="fs-4 text-center fw-bold text-success"
                                        value={precoPromoConcDigitado}
                                        onChange={e => setPrecoPromoConcDigitado(e.target.value)}
                                    />
                                </Col>
                            </Row>

                            <div className="d-grid mb-3">
                                <Button size="sm" variant="outline-secondary" className="fw-bold text-dark" onClick={handleMarkNotFound}>
                                    🚫 Marcar como "Não Encontrado" (Preço 0,01)
                                </Button>
                            </div>

                            {permiteSimilarPesquisa && (
                                <>
                                    <Form.Check
                                        type="switch"
                                        id="switch-similar"
                                        label="Produto Não Encontrado - Coletar Similar/Substituto"
                                        checked={isSimilar}
                                        onChange={e => setIsSimilar(e.target.checked)}
                                        className="fw-bold text-secondary mb-2"
                                    />

                                    {isSimilar && (
                                        <Card className="p-2 bg-warning bg-opacity-10 border-warning mb-3">
                                            <Row className="g-2">
                                                <Col md={8}>
                                                    <Form.Label className="extra-small fw-bold mb-1">Nome / Marca do Similar</Form.Label>
                                                    <Form.Control size="sm" type="text" placeholder="Ex: Guaraná Antarctica 2L" value={similarNome} onChange={e => setSimilarNome(e.target.value)} />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Label className="extra-small fw-bold mb-1">EAN do Similar</Form.Label>
                                                    <div className="d-flex gap-1">
                                                        <Form.Control size="sm" type="text" placeholder="EAN" value={similarEan} onChange={e => setSimilarEan(e.target.value)} />
                                                        <Button size="sm" variant="secondary" onClick={() => { setScanTarget('similar'); setShowScanner(true); }}>
                                                            <FaCamera />
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    )}
                                </>
                            )}

                            <div className="d-grid">
                                <Button className="btn-custom-red btn-lg fw-bold" onClick={handleSalvarColeta}>
                                    <FaCheck className="me-2" /> Gravar Preço
                                </Button>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <BarcodeModal
                show={showScanner}
                onClose={() => setShowScanner(false)}
                onScanSuccess={(codigo) => {
                    if (isProcessingScan) return;
                    setIsProcessingScan(true);
                    playBeep();
                    setShowScanner(false);
                    if (scanTarget === 'similar') {
                        setSimilarEan(codigo);
                    } else {
                        setEanInput(codigo);
                        handleBuscarEan(codigo);
                    }
                    setTimeout(() => setIsProcessingScan(false), 800);
                }}
            />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />

            <Footer />
        </div>
    );
}